<template>
  <RkTable :data="equityChangeData" :loading="loading" :finished="finished" @load="getHoldChangeData">
    <RkTableColumn prop="dateOfChange" label="变动日期" fixed align="left" :width="`${postcssPatch(100)}`">
      <template slot-scope="{ row }">{{ $digitjs(row.dateOfChange).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="totalShares" label="总股本" :width="`${postcssPatch(90)}`">
      <template slot-scope="{ row }">{{ $digitjs(row.totalShares).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="totalSharesChangeRatio" label="变动比例" :width="`${postcssPatch(90)}`">
      <template slot-scope="{ row }">{{ $digitjs(row.totalSharesChangeRatio).unit('%').rounded() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="floatShares" label="流通股本" :width="`${postcssPatch(90)}`">
      <template slot-scope="{ row }">{{ $digitjs(row.floatShares).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="floatSharesChangeRatio" label="变动比例" :width="`${postcssPatch(90)}`">
      <template slot-scope="{ row }">{{ $digitjs(row.floatSharesChangeRatio).unit('%').rounded() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="reasonOfChange" label="变动原因" :width="`${postcssPatch(120)}`">
      <template slot-scope="{ row }">{{ $t($digitjs(shareChangeReasonOfHs[row.reasonOfChange]).isNull()) }}</template>
    </RkTableColumn>
  </RkTable>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'
import { shareChangeReasonOfHs } from '@/utils/constant'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      equityChangeData: []
    }
  },
  computed: {
    shareChangeReasonOfHs() {
      return shareChangeReasonOfHs
    },
    symbol() {
      return this.$route.query.symbol
    }
  },
  methods: {
    postcssPatch,
    async getHoldChangeData() {
      this.loading = true
      this.pageNum++
      const res = await this.$post(this.$api.f10.hs + '/summary/share-structure', {
        type: 'S',
        symbol: this.symbol
      })
      this.equityChangeData = res.data?.filter((i) => shareChangeReasonOfHs[i.reasonOfChange]) ?? []
      this.loading = false
      this.finished = true
    }
  }
}
</script>
